import { connect } from 'react-redux';
import { compose, withProps } from 'recompose';
import withMinuteOptions from '../../../common/hoc/withMinuteOptions';
import { activeShop, getActiveType, getRoleIdType, getShops } from '../../../auth/selectors';

export default compose(
  connect(state => ({
    shops: getActiveType(state) === 'barber' ? [activeShop(state)] : getShops(state),
    roleIdType: getRoleIdType(state),
  })),
  withProps((ownProps) => {
    const isAddMode = !ownProps.service;
    const isBrand = ownProps.roleIdType.type === 'brand';

    /**
     * When brand is creating service, if there is any shop that have 15 min interval,
     * we need to use 15min interval in service form.
     */
    if (isBrand && isAddMode) {
      return { minInterval: ownProps.shops.some(shop => shop.minInterval === 15) ? 15 : 5 };
    }

    /**
     * When brand is editing service, if there is any shop that have 5 min interval,
     * we need to use 5min interval in service form.
     */
    if (isBrand && !isAddMode) {
      return { minInterval: ownProps.shops.some(shop => shop.minInterval === 5) ? 5 : 15 };
    }

    /**
     * When shop or barber edit the service there will be used shop interval.
     */
    if (['shop', 'barber'].includes(ownProps.roleIdType.type) && !isAddMode) {
      return { minInterval: ownProps.shop.minInterval };
    }

    return { minInterval: 15 };
  }),
  withMinuteOptions
);
